import { render, staticRenderFns } from "./Creditos.vue?vue&type=template&id=8b1f428e&scoped=true&"
import script from "./Creditos.vue?vue&type=script&lang=js&"
export * from "./Creditos.vue?vue&type=script&lang=js&"
import style0 from "./Creditos.vue?vue&type=style&index=0&id=8b1f428e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1f428e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VPagination,VRow,VSimpleTable,VSpacer,VTextField})
